import api from './client';
import type { Ordre } from 'types/ordre';
import type { ListParams } from './types';

export const ordresApi = {
  list: async (params?: ListParams & { org_id?: string; status?: string; assigned_to?: string; dossier_id?: string; offset?: number; sort_by?: string; sort_dir?: string }): Promise<Ordre[]> => {
    const { data } = await api.get('/ordres', { params });
    return data;
  },

  get: async (id: string): Promise<Ordre> => {
    const { data } = await api.get(`/ordres/${id}`);
    return data;
  },

  create: async (ordre: Omit<Ordre, 'id'>): Promise<Ordre> => {
    const { data } = await api.post('/ordres', ordre);
    return data;
  },

  update: async (id: string, updates: Partial<Ordre>): Promise<Ordre> => {
    const { data } = await api.patch(`/ordres/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/ordres/${id}`);
  },

  uploadDocument: async (ordreId: string, file: File, name?: string, documentType?: string): Promise<Ordre> => {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);
    if (documentType) formData.append('document_type', documentType);
    const { data } = await api.post(`/ordres/${ordreId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  getDocumentUrl: async (ordreId: string, documentId: string): Promise<string> => {
    const { data } = await api.get(`/ordres/${ordreId}/documents/${documentId}/url`);
    return data.url;
  },

  addVehicleBookingEvent: async (ordreId: string, payload: { vehicle_plate: string; vehicle_name: string; start_date: string; end_date: string }): Promise<Ordre> => {
    const { data } = await api.post(`/ordres/${ordreId}/vehicle-booking-event`, payload);
    return data;
  },

  sendSignRequest: async (ordreId: string, documentId: string, signerName: string, signerEmail: string): Promise<{ success: boolean; token: string; signing_url: string }> => {
    const { data } = await api.post(`/ordres/${ordreId}/documents/${documentId}/sign-request`, {
      signer_name: signerName,
      signer_email: signerEmail,
      document_id: documentId,
    });
    return data;
  },
};
